<template>
  <div aria-live="assertive" aria-atomic="true" aria-relevant="text" class="mdl-snackbar mdl-js-snackbar">
    <div class="mdl-snackbar__text"></div>
    <button type="button" class="mdl-snackbar__action"></button>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    show (message) {
      let notification = document.querySelector('.mdl-js-snackbar')
      notification.MaterialSnackbar.showSnackbar({ message: message })
    }
  },
  mounted () {
    this.$toast.show = this.show
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// index.vue?900ab9ba